import { media, styled } from '@styles';
import { pageTitle } from '@styles/utils';
import { Container } from '@components/templates/Container';

export const Wrapper = styled(Container)`
  padding: 100px 0;
  ${media.largeScreen`
    padding: 75px 0;
  `}
  ${media.smallScreen`
    padding: 50px 0;
  `}
`;

export const Header = styled.div`
  ${pageTitle}
  text-align: center;
  margin-bottom: 35px;
  ${media.largeScreen`
    margin-bottom: 25px;
  `}
  ${media.smallScreen`
    margin-bottom: 15px;
  `}
  &:before {
    content: none;
  }
`;

export const Description = styled.div`
  max-width: 880px;
  text-align: center;
  font-size: ${(props) => props.theme.typography.baseFontSize};
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  line-height: 1.6em;
  text-align: center;
  margin: 0 auto 63px;
  opacity: 0.8;
  ${media.largeScreen`
    margin-bottom: 40px;
    max-width: 650px;
  `}
  ${media.smallScreen`
    margin-bottom: 30px;
  `}
  * {
    font: inherit;
    line-height: inherit;
  }
`;

export const Colors = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 75px;
  ${media.largeScreen`
    margin-bottom: 60px;
  `}
  ${media.smallScreen`
    margin-bottom: 40px;
  `}
  .color-sample__colors-item {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    margin: 0 3px;
    text-indent: -99999px;
    transition: box-shadow 0.4s;
    &:hover,
    &.active {
      box-shadow: inset 0 0 0 4px rgba(#fff, 0.3);
    }
    ${media.largeScreen`
      width: 36px;
      height: 36px;
    `}
    ${media.smallScreen`
      width: 24px;
      height: 24px;
    `}
  }
`;

export const Link = styled.div`
  text-align: center;
`;
